import { FormBuilder, FormGroup, Validators, FormControl, NgForm, AbstractControl } from '@angular/forms';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpParams } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-video-modal',
  templateUrl: './video-modal.component.html',
  styleUrls: ['./video-modal.component.scss'],
  providers: []
})
export class VideoModalComponent implements OnInit {

 @Input() src;

public srcSafe:any;


  constructor(
      public activeModal: NgbActiveModal,
      private formBuilder: FormBuilder,
      public sanitizer: DomSanitizer

     
  ) { }

  ngOnInit()
  {

     this.srcSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.src);
     
  }



close()
{
   this.activeModal.dismiss('close');
}

}
